import emptyFieldValidate from "@validators/shared/empty.validate";
import { textLength } from "@validators/shared/textLength.validate";

export type TErrors = {
  title: string | undefined;
  date: string | undefined;
  summary: string | undefined;
  body: string | undefined;
  imageUrl: string | undefined;
};

const newsValidate = (FormValues: Record<string, any>) => {
  let errors: TErrors = {
    title: undefined,
    date: undefined,
    summary: undefined,
    body: undefined,
    imageUrl: undefined,
  };

  errors.title = textLength(FormValues.title, "Title", 200, 4);
  errors.date = emptyFieldValidate(FormValues.date, "Date");
  errors.summary = textLength(FormValues.summary, "Summary", 400);
  errors.body = emptyFieldValidate(FormValues.body, "Body");
  errors.imageUrl = emptyFieldValidate(FormValues.imageUrl, "Image");

  return errors;
};

export default newsValidate;
